import { businessDaysManagementApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const BUSINESS_DAYS_ACTION_TYPE = createNamedActions('businessDays', {
  GET_BUSINESS_DAYS: 'GET_BUSINESS_DAYS',
  UPDATE_BUSINESS_DAYS: 'UPDATE_BUSINESS_DAYS',
  GET_POTENTIAL_BUSINESS_DAYS: 'GET_POTENTIAL_BUSINESS_DAYS',
});

export const getBusinessDaysAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await businessDaysManagementApi.getCompanyBusinessDays(params);

  return dispatch({
    type: BUSINESS_DAYS_ACTION_TYPE.GET_BUSINESS_DAYS,
    payload: data,
  });
});

export const updateBusinessDaysAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await businessDaysManagementApi.updateCompanyBusinessDays(params);

  return dispatch({
    type: BUSINESS_DAYS_ACTION_TYPE.UPDATE_BUSINESS_DAYS,
    payload: data,
  });
});

export const getPotentialBusinessDaysAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await businessDaysManagementApi.getPotentialBusinessDays(params);

  return dispatch({
    type: BUSINESS_DAYS_ACTION_TYPE.GET_POTENTIAL_BUSINESS_DAYS,
    payload: data,
  });
});
